import styled from '@emotion/styled';
import { theme } from '@kindur/components';
import React from 'react';

import chatBubble from '../../icons/smartdraw/chat.svg';
import { openChatWindow } from '../../utils/helpers';

const ChatWithUs = styled('button')`
  align-items: center;
  background: transparent;
  border: 0;
  cursor: pointer;
  display: flex;
  flex-flow: row nowrap;
  color: #123330;
  font-family: 'Apercu Pro Regular', sans-serif;
  font-size: 16px;
  letter-spacing: 0.2px;
  line-height: 28px;
  img {
    height: 20px;
    margin-right: 8px;
    width: 26px;
  }
  span {
    white-space: nowrap;
  }
  ${theme.breakpoints.mobileDown} {
    padding: 16px;
  }
`;

export default ({ text, track, trackEventParent = 'ChatWithUs' }) => (
  <ChatWithUs
    onClick={() => {
      track(`Chat`, trackEventParent);
      openChatWindow();
    }}
  >
    <img alt={'speech bubble'} src={chatBubble} />
    <span>{text || `Chat With Us`}</span>
  </ChatWithUs>
);
